export class UploadedFileViewModel {
    constructor() {
        this.OldGuidCollection = new Array<string>();
    }

    public Name = '';
    public Size: number;
    public Progress?: number;
    public Guid: string;
    public OldGuidCollection?: string[];
    public MarkToDelete? = false;
}

export class DeleteFilesViewModel {
    public guids: string[];
    public module: string;
}

export enum DocumentModule {
    Default = 'file', // Endpoint por defecto: 'api/core/file/
    Gestor = 'doc', // Gestor de contenidos: 'api/core/doc/'
    Campania = 'camdoc', // Módulo de Solicitudes de Campaña: 'api/core/camdoc/'
    Laboratorio = 'labdoc', // Endpoint dirigido a (controller) TwDocStorageMuestraLab
}

export enum ValidFileTypes {
    DOC = '.doc',
    DOCX = '.docx',
    EXCEL = '.xls',
    EXCELX = '.xlsx',
    JPEG = '.jpeg',
    JPG = '.jpg',
    PDF = '.pdf',
    PNG = '.png',
    TIFF = '.tiff',
}
